import {
    extractAxiosError,
    appendStandardProperties,
    appendBasePayload
} from './common.logging';

const LEVEL = {
    Error: 'Error',
    Info: 'Info',
    Warn: 'Warn'
};

const MODE = 'client';

class LogService {
    #sentry;

    #justLog;

    #store;

    constructor (sentry, justLog, store) {
        this.#sentry = sentry;
        this.#justLog = justLog;
        this.#store = store;
    }

    /**
     * Log an error to Just Log and exception in  Sentry
     * @param  {string} message - Describe what happened
     * @param  {object} exception - The actual original exception
     * @param  {string|string[]} tags - Single tag or list of tags so logs can be connected to a team / feature
     * @param  {object} [payload={}] - Any additional properties you want to add to the logs
     */
    error (message, exception, tags, payload = {}) {
        appendStandardProperties(payload, message, LEVEL.Error, MODE, tags);

        const combinedPayload = appendBasePayload({ ...payload, ...extractAxiosError(exception) }, this.#store);
        this.#justLog.error(message, combinedPayload);
        this.#sentry.captureException(exception || payload.error || message);
    }

    /**
     * Log info to Just Log
     * @param  {string} message - Describe what happened
      * @param {string|string[]} tags - Single tag or list of tags so logs can be connected to a team / feature
     * @param  {object} [payload={}] - Any additional properties you want to add to the logs
     */
    info (message, tags, payload = {}) {
        appendStandardProperties(payload, message, LEVEL.Info, MODE, tags);
        const combinedPayload = appendBasePayload(payload, this.#store);
        this.#justLog.info(message, combinedPayload);
    }

    /**
     * Log a warning to Just Log
     * @param  {string} message - Describe what happened
      * @param {string|string[]} tags - Single tag or list of tags so logs can be connected to a team / feature
     * @param  {object} [payload={}] - Any additional properties you want to add to the logs
     */
    warn (message, tags, payload = {}) {
        appendStandardProperties(payload, message, LEVEL.Warn, MODE, tags);
        const combinedPayload = appendBasePayload(payload, this.#store);
        this.#justLog.warn(message, combinedPayload);
    }
}

export default LogService;
